import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/turath2/turath-websites/turath-website-learn/ar-prod/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
